import { TenantProvider } from '../../common/TenantPersona';

export default class DemoProvider extends TenantProvider<{}> {}
